import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  NavigationExtras,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import {
  BASE_NAVIGATE_PATH,
  LOGIN_SERVICE,
  LoginStatus,
} from './login.service';

export function checkLoginStatus(
  allowedList: LoginStatus | LoginStatus[] = [LoginStatus.LOGGED],
  denyNavigate: { commands: any[]; extras?: NavigationExtras } = {
    commands: ['login', 'form'],
    extras: {},
  },
  {
    redirectAfterLogin = false,
    showLoginOrRegisterToBuyDialog = false,
  }: {
    redirectAfterLogin?: boolean;
    showLoginOrRegisterToBuyDialog?: boolean;
  } = {},
) {
  return async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const loginService = inject(LOGIN_SERVICE);
    const baseNavigatePath = inject(BASE_NAVIGATE_PATH);
    const router = inject(Router);

    await loginService.afterAutoLogin.promise;

    const status = await firstValueFrom(
      loginService.status$.pipe(
        filter((status) => status !== LoginStatus.INIT),
      ),
    );

    if (!Array.isArray(allowedList)) {
      allowedList = [allowedList];
    }

    if (!allowedList.includes(status)) {
      if (redirectAfterLogin) {
        const currentUrl = state.url;
        localStorage.setItem('redirectAfterLogin', currentUrl);
      }

      const denyNavigateIsLoginPage = denyNavigate.commands[0] === 'login';
      if (showLoginOrRegisterToBuyDialog && denyNavigateIsLoginPage) {
        localStorage.setItem('showLoginOrRegisterToBuyDialog', 'true');
      }

      denyNavigate.commands.unshift(baseNavigatePath);
      router.navigate(denyNavigate.commands, denyNavigate.extras);
    }

    return true;
  };
}
